import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ConversationView } from "~/components/conversation-view";

export const Route = createFileRoute(
  "/coach/_backend/messages/$conversationId/",
)({
  head: () => ({
    title: "Client Conversation – Dream Coach Match",
    meta: [
      {
        name: "description",
        content: "View your conversation with a potential client",
      },
    ],
  }),
  component: CoachConversationPage,
});

function CoachConversationPage() {
  const { conversationId } = Route.useParams();

  const config = {
    senderContext: "coach" as const,
    conversationId,
    backLinkTo: "/coach/messages",
    backLinkText: "Back to Messages",
    queryKey: "coach-conversations",
    containerClassName: "space-y-6",
    userMessageColor: "bg-purple-700 text-white",
    otherMessageColor: "bg-gray-100 text-gray-900",
    showProfilePictures: true,
    layout: "sidebar" as const,
  };

  return <ConversationView config={config} />;
}
